import "../../../../src/content/esperanza-cochabamba/cochabamba.scss";
import * as React from 'react';
export default {
  React
};